import React from "react";
import ReactDOM from "react-dom";
import {MiniGrantApplication} from "../components/MiniGrantApplication";

export const insertMiniGrantApplication = () => {
  const apps = document.querySelectorAll('[data-fqxi-type="mini-grant-application"]');

  if (apps.length === 0) {
    return;
  }

  apps.forEach((element) => {
    ReactDOM.render(<MiniGrantApplication />, element);
  });
};
